import React from 'react';
import * as R from 'ramda';
import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Dropdown } from '@cowsquare/design';

const RoleBlock = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const Avatar = styled.div`
  display: inline-block;
  height: 30px;
  width: 30px;
  line-height: 30px;
  border-radius: 50%;
  color: ${themeGet('colors.blacks.0')};
  background-color: ${themeGet('colors.primaryUltralight')};
  text-align: center;

  &:hover {
    color: ${themeGet('colors.whites.0')};
    background-color: ${themeGet('colors.primary')};
  }

  &:active {
    color: ${themeGet('colors.whites.0')};
    background-color: ${themeGet('colors.primaryDark')};
  }

  ${props =>
    props.avatar &&
    css`
      background-image: url(${props.avatar});
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    `}

  ${props =>
    !props.avatar &&
    css`
      &::before {
        content: "${props.name}";
      }
    `}
`;

export const AvatarDropdown = ({ selectedItem, onChange, options, user, avatar }) => {
  const name = R.pipe(R.pathOr('', ['name', 0]), R.toUpper)(user);
  return (
    <Dropdown
      itemToString={R.identity}
      selectedItem={selectedItem}
      onChange={onChange}
      options={options}
      placement="bottomRight"
      render={({ getInputProps, toggleMenu }) => (
        <RoleBlock onClick={toggleMenu} {...getInputProps()}>
          <Avatar avatar={avatar} name={name} />
        </RoleBlock>
      )}
    />
  );
};
